import React, { useState } from "react";
import { Modal, Row, Col, Form } from "react-bootstrap";
import {
  FiPlus,
  FiTrash2,
  FiX,
} from "react-icons/fi";

const defaultEarning = {
  basic: "",
  da: "",
  hra: "",
  conveyance: "",
  allowance: "",
  medical: "",
  others: "",
};

const defaultDeduction = {
  tds: "",
  esi: "",
  pf: "",
  leave: "",
  tax: "",
  labour: "",
  others: "",
};

export default function EditSalaryModal({ show, handleClose }) {
  const [earnings, setEarnings] = useState([defaultEarning]);

  const [deductions, setDeductions] = useState([defaultDeduction]);

  const addEarning = () => {
    setEarnings([...earnings, defaultEarning]);
  };

  const deleteEarning = (index) => {
    const updated = [...earnings];
    updated.splice(index, 1);
    setEarnings(updated);
  };

  const addDeduction = () => {
    setDeductions([...deductions, defaultDeduction]);
  };

  const deleteDeduction = (index) => {
    const updated = [...deductions];
    updated.splice(index, 1);
    setDeductions(updated);
  };

  return (
    <Modal
      show={show}
      onHide={handleClose}
      centered
      size="lg"
      className="salary-modal"
    >
 <Modal.Header className="salary-modal-header border-0 position-relative">
  <Modal.Title className="salary-modal-title">
    Add Employee Salary
  </Modal.Title>

  <button
    type="button"
    className="salary-close-btn"
    onClick={handleClose}
  >
    <FiX />
  </button>
</Modal.Header>

      <Modal.Body>
        <Row>
          <Col md={6}>
            <Form.Group className="mb-3">
              <Form.Label>Employee Name</Form.Label>

              <Form.Select className="salary-input">
                <option>Select</option>
                <option>Anthony Lewis</option>
                <option>Brian Villalobos</option>
              </Form.Select>
            </Form.Group>
          </Col>

          <Col md={6}>
            <Form.Group className="mb-3">
              <Form.Label>Net Salary</Form.Label>

              <Form.Control
                type="text"
                className="salary-input"
              />
            </Form.Group>
          </Col>
        </Row>

        {/* Earnings */}
        <div className="salary-section-header">
          <h6>Earnings</h6>

          <button
            className="salary-add-new"
            onClick={addEarning}
          >
            <FiPlus />
            Add New
          </button>
        </div>

        {earnings.map((item, index) => (
          <div key={index} className="mb-3">
            <Row>
              <Col md={3}>
                <Form.Group className="mb-3">
                  <Form.Label>Basic</Form.Label>
                  <Form.Control className="salary-input" />
                </Form.Group>
              </Col>

              <Col md={3}>
                <Form.Group className="mb-3">
                  <Form.Label>DA(40%)</Form.Label>
                  <Form.Control className="salary-input" />
                </Form.Group>
              </Col>

              <Col md={3}>
                <Form.Group className="mb-3">
                  <Form.Label>HRA(15%)</Form.Label>
                  <Form.Control className="salary-input" />
                </Form.Group>
              </Col>

              <Col md={3}>
                <Form.Group className="mb-3">
                  <Form.Label>Conveyance</Form.Label>
                  <Form.Control className="salary-input" />
                </Form.Group>
              </Col>

              <Col md={3}>
                <Form.Group className="mb-3">
                  <Form.Label>Allowance</Form.Label>
                  <Form.Control className="salary-input" />
                </Form.Group>
              </Col>

              <Col md={3}>
                <Form.Group className="mb-3">
                  <Form.Label>Medical Allowance</Form.Label>
                  <Form.Control className="salary-input" />
                </Form.Group>
              </Col>

              <Col md={3}>
                <Form.Group className="mb-3">
                  <Form.Label>Others</Form.Label>
                  <Form.Control className="salary-input" />
                </Form.Group>
              </Col>

              {index !== 0 && (
                <Col md={1} className="d-flex align-items-center">
                  <button
                    className="salary-delete-btn"
                    onClick={() => deleteEarning(index)}
                  >
                    <FiTrash2 />
                  </button>
                </Col>
              )}
            </Row>
          </div>
        ))}

        {/* Deductions */}
        <div className="salary-section-header mt-4">
          <h6>Deductions</h6>

          <button
            className="salary-add-new"
            onClick={addDeduction}
          >
            <FiPlus />
            Add New
          </button>
        </div>

        {deductions.map((item, index) => (
          <div key={index}>
            <Row>
              <Col md={3}>
                <Form.Group className="mb-3">
                  <Form.Label>TDS</Form.Label>
                  <Form.Control className="salary-input" />
                </Form.Group>
              </Col>

              <Col md={3}>
                <Form.Group className="mb-3">
                  <Form.Label>ESI</Form.Label>
                  <Form.Control className="salary-input" />
                </Form.Group>
              </Col>

              <Col md={3}>
                <Form.Group className="mb-3">
                  <Form.Label>PF</Form.Label>
                  <Form.Control className="salary-input" />
                </Form.Group>
              </Col>

              <Col md={3}>
                <Form.Group className="mb-3">
                  <Form.Label>Leave</Form.Label>
                  <Form.Control className="salary-input" />
                </Form.Group>
              </Col>

              <Col md={3}>
                <Form.Group className="mb-3">
                  <Form.Label>Prof.Tax</Form.Label>
                  <Form.Control className="salary-input" />
                </Form.Group>
              </Col>

              <Col md={3}>
                <Form.Group className="mb-3">
                  <Form.Label>Labour Welfare</Form.Label>
                  <Form.Control className="salary-input" />
                </Form.Group>
              </Col>

              <Col md={3}>
                <Form.Group className="mb-3">
                  <Form.Label>Others</Form.Label>
                  <Form.Control className="salary-input" />
                </Form.Group>
              </Col>

              {index !== 0 && (
                <Col md={1} className="d-flex align-items-center">
                  <button
                    className="salary-delete-btn"
                    onClick={() => deleteDeduction(index)}
                  >
                    <FiTrash2 />
                  </button>
                </Col>
              )}
            </Row>
          </div>
        ))}
      </Modal.Body>

      <Modal.Footer>
        <button className="salary-cancel-btn" onClick={handleClose}>
          Cancel
        </button>

        <button className="salary-submit-btn">
          Add Employee Salary
        </button>
      </Modal.Footer>

      <style>
          {

               `
               .salary-close-btn {
  position: absolute;
  top: 22px;
  right: 18px;

  width: 42px;
  height: 42px;
  border-radius: 50%;
  border: none;

  background: #6b7280;
  color: #fff;

  display: flex;
  align-items: center;
  justify-content: center;

  font-size: 22px;

  transition: 0.3s ease;
}

.salary-close-btn:hover {
  background: #4b5563;
}`
          }
      </style>
    </Modal>
  );
}